module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lee-step lee-panel"
  }, [_c('div', {
    staticClass: "heading justify-between"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Next")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-steps', {
    attrs: {
      "space": 100,
      "direction": "vertical",
      "active": _vm.active
    }
  }, _vm._l((_vm.stepData), function(step) {
    return _c('el-step', {
      key: step.id
    }, [_c('div', {
      slot: "title"
    }, [_vm._v(_vm._s(step.title))]), _vm._v(" "), _c('i', {
      class: step.icon,
      slot: "icon"
    }), _vm._v(" "), _c('div', {
      slot: "description"
    }, [_vm._v(_vm._s(step.description))])])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09a59ece","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/step.vue
// module id = 596
// module chunks = 1